import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import { connectLong, beforeLong, stopLong } from '@/services/LongLink';
import { dispatch, getState } from '@@/store';
import { judgeObj, logColor } from '@/shared/functions';
import { addPollingMechanism } from '@/shared/screenAndLongLinkConfig';
const initState = {
    hasLiten: 0,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /** 建立监听 */
        listen(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                if (state.hasLiten === 0) {
                    logColor('tenantCode is: ', getState().userInfo.user.tenantCode, 'color: orange');
                    const _param = {
                        qs: { groupName: getState().userInfo.user.tenantCode || '01151815' },
                    };
                    const pushHubMethod = beforeLong(_param);
                    logColor('pushHubMethod is: ', pushHubMethod, 'color: orange');
                    try {
                        console.log('is in pushHubMethod.client,', pushHubMethod.client);
                    }
                    catch (err) {
                        if (addPollingMechanism) {
                            dispatch.screenLoop.loop({});
                        }
                        throw (`服务器挂了，没有给机会建立连接 err:${err}`);
                    }
                    pushHubMethod.client.upCar = (msg) => {
                        this.dealListen({
                            type: 'upCar',
                            data: msg,
                        });
                    };
                    pushHubMethod.client.roundStatus = (msg) => {
                        this.dealListen({
                            type: 'roundStatus',
                            data: msg,
                        });
                    };
                    pushHubMethod.client.price = (msg) => {
                        this.dealListen({
                            type: 'price',
                            data: msg,
                        });
                    };
                    pushHubMethod.client.carResult = (msg) => {
                        this.dealListen({
                            type: 'carResult',
                            data: msg,
                        });
                    };
                    pushHubMethod.client.countDownStart = (msg) => {
                        this.dealListen({
                            type: 'countDownStart',
                            data: msg,
                        });
                    };
                    pushHubMethod.client.countDownSuspended = (msg) => {
                        this.dealListen({
                            type: 'countDownSuspended',
                            data: msg,
                        });
                    };
                    pushHubMethod.client.countDownRestore = (msg) => {
                        this.dealListen({
                            type: 'countDownRestore',
                            data: msg,
                        });
                    };
                    pushHubMethod.client.biddingPrice = (msg) => {
                        this.dealListen({
                            type: 'biddingPrice',
                            data: msg,
                        });
                    };
                    pushHubMethod.client.auctionStatus = (msg) => {
                        this.dealListen({
                            type: 'auctionStatus',
                            data: msg,
                        });
                    };
                    pushHubMethod.client.priviewCarDown = (msg) => {
                        this.dealListen({
                            type: 'priviewCarDown',
                            data: msg,
                        });
                    };
                    pushHubMethod.client.addCar = (msg) => {
                        this.dealListen({
                            type: 'addCar',
                            data: msg,
                        });
                    };
                    this.SET_STATE({ hasLiten: state.hasLiten + 1 });
                    connectLong();
                }
                else {
                    this.SET_STATE({ hasLiten: state.hasLiten + 1 });
                }
            });
        },
        /** 断开链接 */
        disconnect(payload, { update, state, rootState }) {
            if ((state.hasLiten - 1) === 0) {
                // 关闭链接
                stopLong();
                this.RESET_STATE();
            }
            else {
                this.SET_STATE({ hasLiten: state.hasLiten - 1 });
            }
        },
        dealListen({ type, data }, { update, state, rootState }) {
            const message = JSON.parse(data);
            logColor('收到推送类型', type, '的推送信息：', message, 'color: purple');
            if (judgeObj(message)) {
                switch (type) {
                    case 'upCar':
                        dispatch.screen.upCar(message);
                        break;
                    case 'roundStatus':
                        // 如果是同一个场次
                        if (rootState.screen.sessionId === message.roundId) {
                            dispatch.screen.roundStatus(message);
                        }
                        if (rootState.auctionOperate.sessionId === message.roundId) {
                            dispatch.auctionOperate.roundStatus(message);
                        }
                        break;
                    case 'price':
                        // 如果是同一辆竞拍车
                        if (rootState.screen.nowCarAuctionId === message.auctionId) {
                            dispatch.screen.price(message);
                        }
                        if (rootState.auctionOperate.nowCarAuctionId === message.auctionId) {
                            dispatch.auctionOperate.price(message);
                        }
                        break;
                    case 'carResult':
                        // 如果是同一辆竞拍车
                        if (rootState.screen.nowCarAuctionId === message.auctionId) {
                            dispatch.screen.carResult(message);
                        }
                        if (rootState.auctionOperate.nowCarAuctionId === message.auctionId) {
                            dispatch.auctionOperate.carResult(message);
                        }
                        break;
                    case 'countDownStart':
                        // 如果是同一辆竞拍车
                        if (rootState.screen.nowCarAuctionId === message.auctionId) {
                            dispatch.screen.countDownStart(message);
                        }
                        break;
                    case 'countDownSuspended':
                        // 如果是同一辆竞拍车
                        if (rootState.screen.nowCarAuctionId === message.auctionId) {
                            dispatch.screen.countDownSuspended(message);
                        }
                        break;
                    case 'countDownRestore':
                        // 如果是同一辆竞拍车
                        if (rootState.screen.nowCarAuctionId === message.auctionId) {
                            dispatch.screen.countDownRestore(message);
                        }
                        break;
                    case 'biddingPrice':
                        // 如果是同一辆竞拍车
                        if (rootState.screen.nowCarAuctionId === message.auctionId) {
                            dispatch.screen.biddingPrice(message);
                        }
                        break;
                    case 'auctionStatus':
                        // 如果是同一辆竞拍车
                        if (rootState.screen.nowCarAuctionId === message.auctionId) {
                            dispatch.screen.auctionStatus(message);
                        }
                        break;
                    case 'priviewCarDown':
                        // 如果是同一场次
                        if (rootState.auctionOperate.sessionId === message.roundId) {
                            dispatch.auctionOperate.priviewCarDown(message);
                        }
                        break;
                    case 'addCar':
                        // 如果是同一场次
                        if (rootState.auctionOperate.sessionId === message.roundId) {
                            dispatch.auctionOperate.addCar(message);
                        }
                        break;
                }
            }
            dispatch.addPrice.dealListen({
                type,
                data,
            });
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
    },
});
